import {Type} from 'main.core';

export class PreorderButtonChanger {
    constructor(options = {}) {
        this.el = options.el;

        this.product = options.parent;
        if (this.product) {
            this.product.subscribe('offerChange', this.onProductOfferChange.bind(this));
        }
    }

    onProductOfferChange(e) {
        const eventData = e.getData();
        const storeForm = eventData.newOffer?.storeForm;
        
        if (storeForm && storeForm.URL) {
            this.el.setAttribute('data-local-modal-form', storeForm.URL);
        } else {
            this.el.setAttribute('data-local-modal-form', this.product.preorderButtonDefault);
        }
    }
}